// @mui
import { alpha, styled } from '@mui/material/styles';
import { Popover, ListItemButton, ListItemIcon } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// config
import { ICON } from '../../../config';

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'open',
})(({ active, disabled, open, depth, theme }) => {
    const isLight = theme.palette.mode === 'light';

    const subItem = depth !== 1;

    const activeStyle = {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        ...(!isLight && {
            color: theme.palette.primary.light,
        }),
    };

    const activeSubStyle = {
        color: theme.palette.text.primary,
        backgroundColor: 'transparent',
    };

    const hoverStyle = {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover,
    };

    return {
        flexDirection: 'column',
        textTransform: 'capitalize',
        padding: theme.spacing(0.875, 0),
        color: theme.palette.text.secondary,
        borderRadius: 10,
        transition: theme.transitions.create(['color', 'background-color'], { duration: 150 }),
        '&:hover': hoverStyle,
        // Sub item
        ...(subItem && {
            flexDirection: 'row',
            padding: theme.spacing(1, 2),
            minHeight: 44,
            borderRadius: theme.shape.borderRadius,
        }),
        // Active item
        ...(active && {
            ...activeStyle,
            '&:hover': {
                ...activeStyle,
            },
        }),
        // Active sub item
        ...(subItem &&
      active && {
            ...activeSubStyle,
            '&:hover': {
                ...activeSubStyle,
            },
        }),
        // Open
        ...(open && !active && hoverStyle),
        // Disabled
        ...(disabled && {
            '&.Mui-disabled': {
                opacity: 0.64,
            },
        }),
    };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)({
    marginRight: 0,
    marginBottom: 0,
    width: ICON.NAVBAR_ITEM_MINI,
    height: ICON.NAVBAR_ITEM_MINI,
});

// ----------------------------------------------------------------------

export const StyledPopover = styled(Popover)(({ theme }) => ({
    pointerEvents: 'none',
    '& .MuiPopover-paper': {
        width: 'auto',
        minWidth: 200,
        pointerEvents: 'auto',
        padding: theme.spacing(1, 0),
        marginLeft: theme.spacing(1),
        boxShadow: theme.customShadows.dropdown,
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        ...bgBlur({ color: theme.palette.background.default }),
    },
}));

//
export const createButton = {
    width: 34,
    height: 34,
    minWidth: 34,
    padding: 0,
    marginBottom: '10px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #00B37E 0%, #005249 100%)',
    boxShadow: '0 2px 8px rgba(0, 179, 126, 0.4), inset 0 1px 0 rgba(255,255,255,0.15)',
    border: '1px solid rgba(0, 179, 126, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #00C98A 0%, #006B5E 100%)',
        boxShadow: '0 4px 16px rgba(0, 179, 126, 0.5), inset 0 1px 0 rgba(255,255,255,0.2)',
        transform: 'translateY(-1px)',
    },
    '&:active': {
        transform: 'translateY(0)',
        boxShadow: '0 1px 4px rgba(0, 179, 126, 0.3)',
    },
};